import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/logout')({
  beforeLoad: async ({ context }) => {
    context.authentication?.logout();
  },
  component: () => <div />,
});
